export default __webpack_public_path__ + "static/media/JoshuaBeedleResume.fad78374.pdf";